import { surveySaga } from './survey'
import { questionSaga } from './question'
import { optionSaga } from './option'
import { attemptSaga } from './attempt'
import { answerSaga } from './answer'

export const sagas = [surveySaga(), questionSaga(), optionSaga(), attemptSaga(), answerSaga()]
